import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  styled,
  Table,
  TableBody,
  TableContainer,
  TableCell,
  tableCellClasses,
  TableHead,
  TablePagination,
  TableRow
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const ImportFileToBackend = props => {
  const { settingsConnection } = props;
  const [importFile, setImportFile] = React.useState(null);
  const [listImportFile, setListImportFile] = React.useState([]);
  const [convertSettings, setConvertSettings] = React.useState([]);
  const [fileConvertSelect, setFileConvertSelect] = React.useState([]);
  const [formatSelect, setFormatSelect] = React.useState([]);
  const [executableSelect, setExecutableSelect] = React.useState([]);

  const rowsPerPage = 6;
  const [tablePage, setTablePage] = React.useState(0);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#757575',
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0
    }
  }));

  const urlExportSelect = () => {
    let url;
    if (settingsConnection.server.serverType === 'IGP') {
      url = `http://${settingsConnection.server.ip}:${settingsConnection.server.port}/MG/lidar/export_files`;
    } else if (settingsConnection.server.serverType === 'IGPS') {
      url = `${settingsConnection.server.domain}/MG/lidar/export_files`;
    } else if (settingsConnection.server.serverType === 'input') {
      url = `${settingsConnection.server.domain}/MG/lidar/exec_filter_lidar`;
    }
    return url;
  };
  const urlExportCall = urlExportSelect();

  const urlConvertSelect = () => {
    let url;
    if (settingsConnection.server.serverType === 'IGP') {
      url = `http://${settingsConnection.server.ip}:${settingsConnection.server.port}/MG/lidar/exec_process_files
      `;
    } else if (settingsConnection.server.serverType === 'IGPS') {
      url = `${settingsConnection.server.domain}/MG/lidar/exec_process_files`;
    } else if (settingsConnection.server.serverType === 'input') {
      url = `${settingsConnection.server.domain}/MG/lidar/exec_filter_lidar`;
    }
    return url;
  };
  const urlConvertCall = urlConvertSelect();

  const handleChangePage = (event, newPage) => {
    setTablePage(newPage);
  };

  const loadFileToBack = async event => {
    event.preventDefault();

    if (!importFile) {
      // eslint-disable-next-line no-alert
      alert('Selecciona un archivo primero.');
      return;
    }

    const formData = new FormData();
    formData.append('file', importFile);
    formData.append('disc', 'data3');
    formData.append('passw', 'prueba');

    try {
      const response = await fetch(urlExportCall, {
        method: 'POST',
        body: formData,
        headers: { 'Content-Type': importFile.type },
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });
      console.log('Respuesta del servidor:', await response.json());
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const loadListOfFiles = async () => {
    try {
      const response = await fetch(urlExportCall, {
        method: 'POST',
        body: JSON.stringify({
          file: 'data3'
        }),
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });
      const respuesta = await response.json();
      setListImportFile(respuesta);
      setFileConvertSelect(respuesta[0]);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const convertFile = async prop => {
    try {
      const response = await fetch(urlConvertCall, {
        method: 'POST',
        body: JSON.stringify({
          disc: 'data3',
          execName: prop === 'convert' ? executableSelect.id : 'Request',
          formats: prop === 'convert' ? formatSelect.id : '',
          inputFile: prop === 'convert' ? fileConvertSelect.path : ''
        }),
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });
      if (prop === 'convert') {
        const respuesta = await response.json();
        window.open(respuesta.link);
      } else {
        const respuesta = await response.json();
        setConvertSettings(respuesta);
        setFormatSelect(respuesta.formats[0]);
        setExecutableSelect(respuesta.executables[0]);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <Grid container>
      <Grid item>
        <Box
          component="form"
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            mb: 2
          }}
          noValidate
          autoComplete="off"
        >
          <div>
            <form onSubmit={loadFileToBack} encType="multipart/form-data">
              <input type="file" onChange={event => setImportFile(event.target.files[0])} />
              <button type="submit">Subir Archivo</button>
            </form>
          </div>
          <Button
            variant="outlined"
            size="small"
            color="success"
            onClick={() => {
              loadListOfFiles();
              convertFile('vacio');
            }}
          >
            Lista de archivos
          </Button>
        </Box>
      </Grid>

      {!isEmpty(listImportFile) && (
        <>
          {listImportFile.message ? (
            <h6>{listImportFile.message}</h6>
          ) : (
            <>
              {!isEmpty(listImportFile) && (
                <>
                  <Grid item xs={12}>
                    <TableContainer component={Paper}>
                      <Table aria-label="customized table" size="small" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <StyledTableCell align="left">
                              Lista de archivos subidos
                            </StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {listImportFile
                            .slice(tablePage * rowsPerPage, tablePage * rowsPerPage + rowsPerPage)
                            .map(row => {
                              return (
                                <StyledTableRow key={row.name}>
                                  <StyledTableCell component="th" scope="row">
                                    {row.name}
                                  </StyledTableCell>
                                </StyledTableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[10]}
                      component="div"
                      count={listImportFile.length}
                      rowsPerPage={rowsPerPage}
                      page={tablePage}
                      onPageChange={handleChangePage}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      component="form"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-around',
                        gap: 2,
                        mb: 2,
                        width: '100%'
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      {!isEmpty(convertSettings) && (
                        <>
                          <FormControl fullWidth>
                            <InputLabel id="demo-select-label">Archivo</InputLabel>
                            <Select
                              labelId="demo-select-label"
                              id="demo-select"
                              label="Producto"
                              size="small"
                              value={
                                isEmpty(fileConvertSelect)
                                  ? listImportFile[0].name
                                  : fileConvertSelect.name
                              }
                              onChange={event => {
                                const index = listImportFile.findIndex(
                                  file => file.name === event.target.value
                                );
                                setFileConvertSelect(listImportFile[index]);
                              }}
                            >
                              {listImportFile.map(item => (
                                <MenuItem key={item.name} value={item.name}>
                                  {item.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <FormControl fullWidth>
                            <InputLabel id="demo-select-label">Formato</InputLabel>
                            <Select
                              labelId="demo-select-label"
                              id="demo-select"
                              label="Formato"
                              size="small"
                              value={
                                isEmpty(formatSelect)
                                  ? convertSettings.formats[0].name
                                  : formatSelect.name
                              }
                              onChange={event => {
                                const index = convertSettings.formats.findIndex(
                                  element => element.name === event.target.value
                                );
                                setFormatSelect(convertSettings.formats[index]);
                              }}
                            >
                              {convertSettings.formats.map(item => (
                                <MenuItem key={item.name} value={item.name}>
                                  {item.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <FormControl fullWidth>
                            <InputLabel id="demo-select-label">Tipo de archivo</InputLabel>
                            <Select
                              labelId="demo-select-label"
                              id="demo-select"
                              label="Tipo de archivo"
                              size="small"
                              value={
                                isEmpty(executableSelect)
                                  ? convertSettings.executables[0].name
                                  : executableSelect.name
                              }
                              onChange={event => {
                                const index = convertSettings.executables.findIndex(
                                  element => element.name === event.target.value
                                );
                                setExecutableSelect(convertSettings.executables[index]);
                              }}
                            >
                              {convertSettings.executables.map(item => (
                                <MenuItem key={item.name} value={item.name}>
                                  {item.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <Button
                            variant="outlined"
                            color="success"
                            onClick={() => {
                              convertFile('convert');
                            }}
                          >
                            <DownloadIcon />
                          </Button>
                        </>
                      )}
                    </Box>
                  </Grid>
                </>
              )}
            </>
          )}
        </>
      )}
    </Grid>
  );
};
export default ImportFileToBackend;

ImportFileToBackend.defaultProps = {
  settingsConnection: {}
};
ImportFileToBackend.propTypes = {
  settingsConnection: PropTypes.object
};
